import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { Company } from '@/features/company/types';

interface SelectedCompanyState {
  selectedCompany: Company | null;
  companiesList: Company[];
  isPremiumPlan: boolean;
  expiresAt: string | null;
  setIsPremiumPlan: (isPremiumPlan: boolean) => void;
  setSelectedCompany: (company: Company | null) => void;
  setCompaniesList: (company: Company[]) => void;
  setExpiresAt: (expiresAt: string | null) => void;
}

export const useSelectedCompanyStore = create<SelectedCompanyState>()(
  devtools(
    persist(
      (set) => ({
        selectedCompany: null,
        companiesList: [],
        isPremiumPlan: false,
        expiresAt: null,
        setIsPremiumPlan: (isPremiumPlan) => set(() => ({ isPremiumPlan })),
        setSelectedCompany: (selectedCompany) => set(() => ({ selectedCompany })),
        setCompaniesList: (companiesList) => set(() => ({ companiesList })),
        setExpiresAt: (expiresAt) => set(() => ({ expiresAt })),
      }),
      { name: 'selectedCompanyStore' },
    ),
  ),
);
